import { motion } from "framer-motion";
import { SectionHeader } from "./Reveal";
import { Sparkles } from "./Sparkles";
import { BillboardAd } from "./BillboardAd";
import { COLLAGE_TOP, COLLAGE_BOTTOM } from "../lib/data";

const Cell = ({ c }) => (
    <div className="group overflow-hidden rounded-lg border border-white/12 bg-noir" data-testid={`collage-${c.id}`}>
        <div className="relative aspect-[4/3] overflow-hidden">
            <img
                src={c.img}
                alt={c.label}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-108"
                style={{ transform: "scale(1.001)" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-noir/70 via-transparent to-noir/25" />
            <div className={`absolute left-1/2 -translate-x-1/2 ${c.rideshare ? "top-[10%] w-[56%]" : "top-1/2 w-[64%] -translate-y-1/2"}`}>
                <div className="rounded-md border border-white/25 bg-black/90 p-1 shadow-[0_0_26px_rgba(255,255,255,0.3)]">
                    <div className="relative aspect-[16/8] overflow-hidden rounded-sm">
                        <BillboardAd {...c.ad} tagged={false} compact />
                    </div>
                </div>
                {c.rideshare && <div className="mx-auto h-1.5 w-2/5 rounded-b bg-black/85" />}
            </div>
        </div>
        <div className="bg-gradient-to-r from-hotpink to-hotpink-hover px-2 py-1.5 text-center font-alt text-[8.5px] sm:text-[10px] font-bold tracking-[0.16em] text-white">
            {c.label}
        </div>
    </div>
);

export const Gallery = () => (
    <section id="gallery" className="relative bg-noir py-24 sm:py-32 overflow-hidden" data-testid="gallery-section">
        <div className="absolute top-1/3 -left-32 h-[420px] w-[420px] rounded-full bg-hotpink/10 blur-[130px]" aria-hidden="true" />
        <div className="absolute bottom-0 -right-32 h-[420px] w-[420px] rounded-full bg-gold/10 blur-[130px]" aria-hidden="true" />
        <div className="relative mx-auto max-w-[1200px] px-4 sm:px-6">
            <SectionHeader
                eyebrow="SAMPLE BILLBOARDS"
                title={<>SEE YOUR BRAND <span className="text-pink-gradient italic">IN THE SPOTLIGHT.</span></>}
                sub="One brand. Every screen. Sample advertising formats across our participating advertising and display networks."
            />

            <motion.div
                initial={{ opacity: 0, y: 48, scale: 0.97 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="relative mx-auto max-w-5xl rounded-3xl border-2 border-gold/50 bg-gradient-to-b from-noir-elevated to-noir p-3 sm:p-6 shadow-[0_0_90px_rgba(255,255,255,0.12)]"
                data-testid="billboard-collage"
            >
                <div className="mb-3 sm:mb-5 flex flex-col items-center pt-2">
                    <p className="font-serif text-xl sm:text-3xl font-black tracking-[0.08em] text-gold-gradient">WEALTHHAUS MEDIA</p>
                    <p className="mt-1 font-alt text-[9px] sm:text-[10px] font-bold tracking-[0.5em] text-hotpink">YOUR BRAND. EVERYWHERE.</p>
                </div>

                <div className="grid grid-cols-3 gap-2 sm:gap-3">
                    {COLLAGE_TOP.map((c) => (
                        <Cell key={c.id} c={c} />
                    ))}
                </div>
                <div className="mt-2 sm:mt-3 grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
                    {COLLAGE_BOTTOM.map((c) => (
                        <Cell key={c.id} c={c} />
                    ))}
                </div>
            </motion.div>

            <p className="mt-8 text-center font-alt text-[10px] tracking-[0.22em] text-zinc-500 uppercase" data-testid="gallery-disclaimer">
                Sample billboard images are examples of advertising formats only and do not guarantee a specific
                billboard, screen, location, market, placement, impression count, or advertising inventory.
            </p>
        </div>
    </section>
);
